export default __webpack_public_path__ + "static/media/Clock_perspective_matte_s.d561ab77.png";